import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {TemplateGraph} from "#template/nodes/template-graph/template-graph"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const loadGraphDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    templateId: TD.inlet(TD.Number),
    templateRevisionId: TD.inlet(TD.Nullable(TD.Number)),
    graph: TD.outlet(TD.Identity<TemplateGraph>()),
}

export class LoadGraph implements NodeClassImpl<typeof loadGraphDescriptor, typeof LoadGraph> {
    static descriptor = loadGraphDescriptor
    static uniqueName = "LoadGraph"
    sceneManager!: Inlet<ISceneManager>
    templateId!: Inlet<number>
    templateRevisionId!: Inlet<number | null>
    graph!: Outlet<TemplateGraph>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.templateId === NotReady || this.templateRevisionId === NotReady) {
            this.graph.emitIfChanged(NotReady)
            return
        }

        const {sceneManager, templateId, templateRevisionId} = this

        this.pending = this.sceneManager.addTask({
            description: `loadTemplateGraph(${this.templateId}, ${this.templateRevisionId})`,
            task: defer(() => sceneManager.loadTemplateGraph(templateId, templateRevisionId)).pipe(
                map((graph) => {
                    this.graph.emitIfChanged(graph)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
